import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-audit',
  standalone: true,
  imports: [RouterOutlet, NzTabsModule],
  template: `
    <div class="audit-layout">
      <nz-tabset
        nzType="card"
        [nzSelectedIndex]="activeTabIndex"
        (nzSelectedIndexChange)="onTabChange($event)"
      >
        <nz-tab nzTitle="Audit Events"></nz-tab>
        <nz-tab nzTitle="Routines"></nz-tab>
        <nz-tab nzTitle="Aggregates"></nz-tab>
      </nz-tabset>
      <div class="tab-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [`
    .audit-layout { padding: 16px 24px; }
    .tab-content { margin-top: 16px; }
  `],
})
export class AuditComponent {
  private readonly tabRoutes = ['events', 'routines', 'aggregates'];
  activeTabIndex = 0;

  constructor(private router: Router) {
    const url = this.router.url;
    const idx = this.tabRoutes.findIndex(r => url.includes(`/audit/${r}`));
    this.activeTabIndex = idx >= 0 ? idx : 0;
  }

  onTabChange(index: number): void {
    this.activeTabIndex = index;
    this.router.navigate(['/audit', this.tabRoutes[index]]);
  }
}
